// src/utils/cepUtils.js
import axios from "axios";

export async function buscarEnderecoPorCep(rawCep) {
  const cep = rawCep?.replace(/\D/g, "");

  if (!cep || cep.length !== 8) return null;

  try {
    const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);

    if (response.data.erro) return null;

    return {
      street: response.data.logradouro,
      neighborhood: response.data.bairro,
      city: response.data.localidade,
      state: response.data.uf,
    };
  } catch (error) {
    console.error("Erro na busca do CEP:", error);
    return null;
  }
}
